/** Préférence son de notification — localStorage, partagée desktop/mobile. */

export const MAIL_NOTIFICATION_SOUND_STORAGE_KEY = "mail_notification_sound_v1";

export type MailNotificationSoundId =
  | "off"
  | "classic"
  | "new-message"
  | "incoming"
  | "soft"
  | "chime"
  | "pop"
  | "alert"
  | "announcement"
  | "ding"
  | "revealed";

export type MailNotificationSoundOption = {
  id: MailNotificationSoundId;
  label: string;
  /** null = silencieux */
  file: string | null;
};

/** Silencieux + sons disponibles sous public/sound/. */
export const MAIL_NOTIFICATION_SOUND_OPTIONS: readonly MailNotificationSoundOption[] = [
  { id: "off", label: "Aucun son", file: null },
  { id: "classic", label: "Classique", file: "mail-notification.wav" },
  { id: "new-message", label: "Nouveau message", file: "New Message Notification.mp3" },
  { id: "incoming", label: "Arrivée", file: "Incoming Email 01.wav" },
  { id: "soft", label: "Discret", file: "Notification.mp3" },
  { id: "chime", label: "Carillon", file: "Notification.wav" },
  { id: "pop", label: "Léger", file: "Accept Popper02.mp3" },
  { id: "alert", label: "Alerte", file: "09070 bonus alert.wav" },
  { id: "announcement", label: "Annonce", file: "Announcement Notification 01.wav" },
  { id: "ding", label: "Ding", file: "ding-notification.mp3" },
  { id: "revealed", label: "Ouverture", file: "Notification Revealed.wav" },
] as const;

const OPTION_BY_ID = new Map(
  MAIL_NOTIFICATION_SOUND_OPTIONS.map((option) => [option.id, option])
);

export function mailNotificationSoundUrl(file: string): string {
  return `./sound/${encodeURIComponent(file)}`;
}

export function readMailNotificationSoundId(): MailNotificationSoundId {
  try {
    const raw = localStorage.getItem(MAIL_NOTIFICATION_SOUND_STORAGE_KEY);
    if (raw && OPTION_BY_ID.has(raw as MailNotificationSoundId)) {
      return raw as MailNotificationSoundId;
    }
  } catch {
    /* ignore */
  }
  return "classic";
}

export function persistMailNotificationSoundId(id: MailNotificationSoundId): void {
  try {
    localStorage.setItem(MAIL_NOTIFICATION_SOUND_STORAGE_KEY, id);
  } catch {
    /* ignore */
  }
}

export function getMailNotificationSoundOption(
  id: MailNotificationSoundId = readMailNotificationSoundId()
): MailNotificationSoundOption {
  return OPTION_BY_ID.get(id) ?? MAIL_NOTIFICATION_SOUND_OPTIONS[1];
}
